import { useEffect, useState } from "react";
import { Warning, X } from "@phosphor-icons/react";

function isUnsupported() {
  try {
    return (
      typeof window.ResizeObserver === "undefined" ||
      typeof window.fetch === "undefined" ||
      !window.CSS?.supports?.("color: var(--x)")
    );
  } catch {
    return true;
  }
}

export default function BrowserCompatBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (isUnsupported()) setShow(true);
  }, []);

  if (!show) return null;

  return (
    <div
      className="px-4 py-2.5 text-sm flex items-center gap-2 bg-red-600 text-white"
      data-testid="browser-compat-banner"
    >
      <Warning size={18} weight="fill" />
      <span className="flex-1">
        Tu navegador está desactualizado y algunas partes de CHKR (como los menús desplegables) pueden no funcionar
        correctamente. Actualízalo o abre esta página en Chrome o Safari recientes.
      </span>
      <button
        onClick={() => setShow(false)}
        className="p-1 -m-1 shrink-0"
        aria-label="Cerrar aviso"
        data-testid="browser-compat-dismiss"
      >
        <X size={14} weight="bold" />
      </button>
    </div>
  );
}
